import { ComposedTheme, createUseStyles } from '@glu/theming';
import { ITabIndicatorProps } from './TabIndicator';

type TStyleProps = Pick<ITabIndicatorProps, 'left' | 'vertical'>;

const styles = ({ tabs: { indicator } }: ComposedTheme) => ({
  indicator: ({ left, vertical }: TStyleProps) => ({
    position: 'absolute',
    transition: `all ${indicator.transitionDuration}ms ${indicator.transition}`,
    backgroundColor: indicator.backgroundColor,
    ...(vertical
      ? {
          width: indicator.height,
          [left ? 'left' : 'right']: 0,
        }
      : { height: indicator.height, bottom: 0 }),
  }),
});

export default createUseStyles(styles);
